import { IMAGES, waLink } from "../data/site";

export const Hero = () => {
  return (
    <header data-testid="hero-section" className="max-w-6xl mx-auto px-6 pt-16 pb-20 md:pt-24 md:pb-28">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 space-y-6">
          <p className="text-xs uppercase tracking-[0.18em] text-cognac font-semibold">
            Boutique &amp; Selezione Personale
          </p>
          <h1 className="font-display hero-title font-normal text-ink text-balance">
            <span className="ln"><span>Capi scelti con</span></span>
            <span className="ln"><span>cura, gusto e</span></span>
            <span className="ln"><span>passione autentica.</span></span>
          </h1>
          <p data-testid="hero-subtitle" className="d1-sub text-lg text-ink/80 max-w-xl leading-relaxed">
            Selezioniamo personalmente ogni capo con cura e gusto. Prezzi onesti, qualità
            duratura e il calore di un consiglio sincero tra amiche.
          </p>
          <div className="d1-sub pt-2 flex flex-wrap items-center gap-4">
            <a
              href={waLink("Ciao! Vorrei sapere taglie e disponibilità di un capo visto sul sito.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-whatsapp"
              className="inline-flex items-center gap-3 bg-cognac text-white px-7 py-3.5 rounded-full text-sm font-medium hover:bg-ink transition-colors transform hover:-translate-y-0.5 shadow-sm"
            >
              <span>Richiedi Taglia su WhatsApp</span>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </a>
            <a
              href="#vetrina"
              data-testid="hero-link-vetrina"
              className="text-sm font-medium underline underline-offset-4 decoration-ink/30 hover:decoration-cognac"
            >
              Guarda i nuovi arrivi
            </a>
          </div>
        </div>
        <div className="lg:col-span-5">
          <div className="d1-hero-frame relative rounded-2xl overflow-hidden aspect-[4/5] shadow-xl border border-ink/10">
            <img
              src={IMAGES.hero}
              alt="Giacca in lino su appendiabiti in legno, luce calda di boutique"
              className="absolute inset-0 w-full h-full object-cover d1-drift"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent flex flex-col justify-end p-6 text-white">
              <span className="text-xs uppercase tracking-[0.14em] text-white/80">
                In Negozio &amp; Spedizione Italia
              </span>
              <p className="font-display text-xl font-medium">Nuovi Arrivi Settimanali</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
